import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

type Props = {
    isChatSettingsLoading: boolean;
    isChatEnabled: boolean;
    hasCompletedActions: boolean;
};

export const FunnelReportEmptyState = (props: Props) => {
    if (props.isChatSettingsLoading) {
        return null;
    }

    if (!props.isChatEnabled) {
        return (
            <Stack spacing={24} alignItems='center'>
                <Illustration src='setup-chat' width={290} />
                <Body color='light' textAlign='center'>
                    Set up your Chat widget or Engagement Bar to see how visitors engage, convert to
                    leads, and drive sales.
                </Body>
                {/* @ts-expect-error */}
                <Link as={RouterLink} to='/inbox/settings/chat' variant='button-primary'>
                    Go to Chat settings
                </Link>
            </Stack>
        );
    }

    if (!props.hasCompletedActions) {
        return (
            <Stack spacing={24} alignItems='center'>
                <Illustration src='chart-data-empty-state' width={270} />
                <Body color='light' textAlign='center'>
                    Your Chat widget is ready to go!
                    <br />
                    Data will appear once visitors start engaging with it.
                </Body>
            </Stack>
        );
    }

    return null;
};
